import React from 'react'

export const Alpaka_Patnerschaft = () => {
    return (
        <div className="randBox" id="patenschaft">
            <h2>Alpaka-Patenschaft</h2>
            <p>
                Werde <strong>Patentante</strong> oder <strong>Patenonkel</strong> eines unserer Alpakas - für ein ganzes Jahr! <br />
                Du kannst dein ausgewähltes Tier regelmäßig besuchen, bei der Fütterung helfen und es durchs Jahr begleiten.
            </p>
            <ul>
            <h4>Deine Patenschaft beinhaltet:</h4>
            <ul>
                <li>Eine persönliche <strong>Patenurkunde</strong></li>
                <li><strong>1 Spaziergang pro Quartal</strong> inkl. einer Begleitperson</li>
                <li><strong>1 Entspannungsstunde pro Monat</strong> auf der Alpakawiese inkl. einer Begleitperson</li>
                <li><strong>150€ pro Jahr</strong></li>
            </ul>
            </ul>
            <ul>
      
      <li><strong>Preise:</strong>
          <ul>
          <li>Für ein Jahr: <strong>150€</strong> </li>
          </ul>
      </li>
    </ul>
        </div>
    )
}